import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, MailPlus } from "lucide-react";

const errText = (e) => { const d = e.response?.data?.detail; return d?.message || (typeof d === "string" ? d : "Postcard could not be sent"); };

export const MailNowOffer = ({ ids, onDone, testId = "mail-now" }) => {
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);
  if (!ids?.length) return null;
  const n = ids.length;
  const send = async () => {
    setBusy(true);
    let sent = 0;
    const failed = [];
    for (const id of ids) {
      try { await api.post(`/prospects/${id}/postcard`); sent += 1; }
      catch (e) { failed.push(errText(e)); }
    }
    setBusy(false); setConfirm(false); setDone({ sent, failed });
    if (sent) toast.success(`${sent} postcard${sent > 1 ? "s" : ""} queued for mailing`);
    if (failed.length) toast.error(`${failed.length} not sent: ${failed[0]}`);
    onDone?.();
  };
  if (done) return <div className={`rounded-lg px-3 py-2 text-xs font-semibold ${done.sent ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`} data-testid={`${testId}-done`}>{done.sent} mailed{done.failed.length ? ` · ${done.failed.length} not sent (${done.failed[0]})` : ""}</div>;
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm" data-testid={`${testId}-offer`}>
      <div className="font-semibold text-amber-900">{n === 1 ? "Address fixed — mail this lead's postcard now?" : `${n} addresses fixed — mail their postcards now?`}</div>
      <div className="mt-0.5 text-xs text-amber-800">Free for the MLO · about ${(0.9 * n).toFixed(2)} in PostGrid postage, billed to the company. Leads mailed in the last 30 days are skipped.</div>
      {!confirm ? (
        <Button size="sm" onClick={() => setConfirm(true)} className="mt-2 bg-slate-900 hover:bg-slate-800" data-testid={`${testId}-btn`}><MailPlus className="mr-1.5 h-4 w-4" /> Mail {n === 1 ? "postcard" : `${n} postcards`}</Button>
      ) : (
        <div className="mt-2 flex gap-2">
          <Button size="sm" onClick={send} disabled={busy} className="bg-amber-600 hover:bg-amber-700" data-testid={`${testId}-confirm`}>{busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : null} Yes, mail {n === 1 ? "it" : "them"}</Button>
          <Button size="sm" variant="ghost" onClick={() => setConfirm(false)} disabled={busy} data-testid={`${testId}-cancel`}>Cancel</Button>
        </div>
      )}
    </div>
  );
};
